import Gtm from '@grebban/gtm';
import type { InputError } from '@activebrands/core-web/hooks/useForm';
import type { FormFlow } from '@activebrands/core-web/libs/Events/types';

export default ({ errors, source, flow }: {
    errors: Record<string, InputError[] | undefined>;
    source: 'client' | 'server';
    flow?: FormFlow;
}) => {
    // One event per submission: flatten the per-field map into `field:error_type` tokens.
    const tokens = Object.entries(errors).flatMap(([field, fieldErrors]) =>
        (fieldErrors ?? []).map(({ error }) => `${field}:${error}`)
    );

    if (!tokens.length) {
        return;
    }

    Gtm.addDataLayerEvent('form_error', {
        form_id: flow,
        error_source: source,
        error_count: tokens.length,
        errors: tokens.join(','),
    });
};
